export class ShareButton extends HTMLElement {
  #controller = new AbortController()
  #shareUrl = null
  #shareText = null
  #button = null

  connectedCallback () {
    const { signal } = this.#controller
    this.#button = this.querySelector('button') || this
    this.#shareUrl = this.dataset.shareUrl || window.location.href
    this.#shareText = this.dataset.shareText || document.title

    this.#button.addEventListener('click', this.#handleShareClick, { signal })
  }

  disconnectedCallback () {
    this.#controller.abort()
  }

  #handleShareClick = async event => {
    event.preventDefault()
    if (navigator.share) {
      try {
        await navigator.share({
          title: this.#shareText,
          url: this.#shareUrl
        })
      } catch (error) {
        console.error('Error sharing:', error)
      }
    } else {
      console.warn('Web Share API not supported in this browser.')
    }
  }
}

if (!customElements.get('share-button')) {
  customElements.define('share-button', ShareButton)
}

// class ProductRecommendations extends HTMLElement {
//   constructor () {
//     super()
//   }

//   connectedCallback () {
//     const handleIntersection = (entries, observer) => {
//       if (!entries[0].isIntersecting) return
//       observer.unobserve(this)

//       fetch(this.dataset.url)
//         .then(response => response.text())
//         .then(text => {
//           const html = document.createElement('div')
//           html.innerHTML = text
//           const recommendations = html.querySelector('product-recommendations')

//           if (recommendations && recommendations.innerHTML.trim().length) {
//             this.innerHTML = recommendations.innerHTML
//           }

//           if (html.querySelector('.grid__item')) {
//             this.classList.add('product-recommendations--loaded')
//           }
//         })
//         .catch(e => {
//           console.error(e)
//         })
//     }

//     new IntersectionObserver(handleIntersection.bind(this), {
//       rootMargin: '0px 0px 400px 0px'
//     }).observe(this)
//   }
// }

// if (!customElements.get('product-recommendations')) {
//   customElements.define('product-recommendations', ProductRecommendations)
// }

class CloseButton extends HTMLElement {
  connectedCallback () {
    this.addEventListener('click', this.#handleClick)
  }

  disconnectedCallback () {
    this.removeEventListener('click', this.#handleClick)
  }

  #handleClick = event => {
    event.preventDefault()
    const targetItem = this.getAttribute('aria-controls')
    let target = null
    if (targetItem) {
      target = document.getElementById(targetItem)
    } else {
      // Find closest section ancestor
      target = this.closest('.shopify-section')
    }
    if (target) {
      target.classList.add('close__item')
    }
  }
}

if (!customElements.get('close-button')) {
  customElements.define('close-button', CloseButton)
}

export class Video extends HTMLElement {
  constructor () {
    super()
    this.button = this.querySelector('.video-btn')
    this.video = this.querySelector('video')
  }

  connectedCallback () {
    if (this.button) {
      this.button.addEventListener('click', e => {
        this.classList.add('video-active')
        this.video.play()
      })
    } else {
      this.classList.add('video-active')
      this.video.pause()
    }
  }

  disconnectedCallback () {
    this.button.removeEventListener('click', this.video)
  }
}

if (!customElements.get('video-component')) {
  customElements.define('video-component', Video)
}

export class InputGroup extends HTMLElement {
  constructor () {
    super()
    this.type = null
    this.name = null
    this.options = null
    this.wrapper = null
  }

  connectedCallback () {
    this.type = this.dataset.type
    this.name = this.dataset.name
    this.options = this.querySelectorAll('.input-option-main')
    this.wrapper = this.querySelector('.option_list')
    this.render()
  }

  render () {
    this.options.forEach((option,index) => {
      let currentOption = option
      let id = option.getAttribute('id')
      let value = `${option.value}-${index}`
      let text = option.textContent
      let elClass = option.getAttribute('class')
      currentOption.value = value
      option.parentElement.remove()
      if (this.type === 'select') {
        this.wrapper.append(currentOption)
      } else {
        let inputWrapper = document.createElement('div')
        inputWrapper.classList.add(`${this.type}-input-wrapper`)
         inputWrapper.classList.add(`input__wrapper`)
        let newInput = document.createElement('input')
        let newLabel = document.createElement('label')
        newLabel.setAttribute('for', id)
        newLabel.textContent = text
        newInput.setAttribute('name', this.name)
        newInput.setAttribute('type', this.type)
        newInput.setAttribute('id', id)
        newInput.setAttribute('value', value)
        newInput.setAttribute('class', elClass)
        inputWrapper.append(newInput)
        inputWrapper.append(newLabel)
        this.wrapper.append(inputWrapper)
      }
    })
  }
}

if (!customElements.get('input-group')) {
  customElements.define('input-group', InputGroup)
}

 class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this._observer = null;
      this._handleIntersection = this._handleIntersection.bind(this);
    }

    connectedCallback() {
      this._observer = new IntersectionObserver(this._handleIntersection, { rootMargin: '0px 0px 200px 0px' });
      this._observer.observe(this);
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
      }
    }

    _handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      const url = this.dataset.url;
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;      
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  if (!customElements.get('product-recommendations')) {
    window.customElements.define('product-recommendations', ProductRecommendations);
  }